export class Redirect {
  loadHandler: EventListener;
  fromUrl: string;
  toUrl: string;

  constructor(fromUrl: string, toUrl: string) {
    if (!fromUrl || !toUrl) {
      return;
    }

    this.fromUrl = fromUrl;
    this.toUrl = toUrl;

    this.bind();
  }

  bind() {
    this.loadHandler = this.handleLoad.bind(this);
    document.addEventListener('DOMContentLoaded', this.loadHandler);
  }

  handleLoad() {
    this.redirect();
  }

  redirect() {
    if (window.location.pathname === this.fromUrl) {
      window.location.replace(this.toUrl);
    }
  }

  unbind() {
    document.removeEventListener('DOMContentLoaded', this.loadHandler);
  }

  destroy() {
    this.unbind();
  }
}
